export default "__VITE_ASSET__DkC5grR3__"